import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import DisplayQualityMdUp from './DisplayQualityMdUp';
import DisplayQualitySmDown from './DisplayQualitySmDown';

export default function DisplayQuality({
  isChanging,
  item,
  onClick,
}) {
  const tooltipData = {
    ...item,
    smallButtons: [{
      label: 'Change',
      action: onClick,
    }],
  };
  return (
    <Fragment>
      <DisplayQualitySmDown
        {...item}
        isChanging={isChanging}
        onClick={onClick}
        tooltipData={tooltipData}
      />
      <DisplayQualityMdUp
        {...item}
        isChanging={isChanging}
        onClick={onClick}
        tooltipData={tooltipData}
      />
    </Fragment>
  );
}

DisplayQuality.displayName = 'DisplayQuality';

DisplayQuality.propTypes = {
  isChanging: PropTypes.bool.isRequired,
  item: PropTypes.shape({
    effectiveLevel: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    level: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    nameAndLevel: PropTypes.string.isRequired,
    nature: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};